var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _vm.popupParam.psiValveRuptureId
                ? _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm revisionLayout",
                      attrs: { title: "LBLREV", topClass: "topcolor-orange" },
                    },
                    [
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-1" },
                                [
                                  _c("c-text", {
                                    attrs: {
                                      required: _vm.editable && _vm.isRevision,
                                      editable: _vm.editable && _vm.isRevision,
                                      label: "LBLREVNO",
                                      name: "revisionNum",
                                    },
                                    model: {
                                      value: _vm.data.revisionNum,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.data, "revisionNum", $$v)
                                      },
                                      expression: "data.revisionNum",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-2" },
                                [
                                  _c("c-text", {
                                    attrs: {
                                      editable: false,
                                      label: "LBLREVPERIOD",
                                      name: "regDtStr",
                                    },
                                    model: {
                                      value: _vm.data.regDtStr,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.data, "regDtStr", $$v)
                                      },
                                      expression: "data.regDtStr",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-1" },
                                [
                                  _c("c-text", {
                                    attrs: {
                                      editable: false,
                                      label: "LBLREVUSER",
                                      name: "regUserName",
                                    },
                                    model: {
                                      value: _vm.data.regUserName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.data, "regUserName", $$v)
                                      },
                                      expression: "data.regUserName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("c-text", {
                                    attrs: {
                                      required: _vm.editable && _vm.isRevision,
                                      editable: _vm.editable && _vm.isRevision,
                                      label: "LBLREVREASON",
                                      name: "revisionContent",
                                    },
                                    model: {
                                      value: _vm.data.revisionContent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "revisionContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.revisionContent",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0010454" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-select" },
                    [
                      _vm.popupParam.psiValveRuptureId
                        ? _c("c-select", {
                            attrs: {
                              editable: !_vm.isRevision,
                              comboItems: _vm.gridrev.data,
                              type: "custom",
                              typetext: "LBL0010565",
                              itemText: "revisionNum",
                              itemValue: "psiValveRuptureId",
                              name: "selectedpsiValveRuptureId",
                              label: "",
                            },
                            on: { input: _vm.rowClickRev },
                            model: {
                              value: _vm.selectedpsiValveRuptureId,
                              callback: function ($$v) {
                                _vm.selectedpsiValveRuptureId = $$v
                              },
                              expression: "selectedpsiValveRuptureId",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c(
                            "q-btn",
                            {
                              staticClass: "custom-btn",
                              attrs: {
                                icon: "help",
                                color: "deep-purple-6",
                                "text-color": "white",
                                align: "center",
                                round: "",
                              },
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "bottom left",
                                    self: "top left",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "tooltipCustomTop" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$label("LBL0010384")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "tooltipCustom" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.$message("MSG0010041"))
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$message("MSG0010042")) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.editable &&
                                  _vm.popupParam.psiValveRuptureId &&
                                  !_vm.isRevision &&
                                  _vm.isEnalbed,
                                expression:
                                  "(editable && popupParam.psiValveRuptureId && !isRevision) && isEnalbed",
                              },
                            ],
                            attrs: { label: "LBLREV", icon: "restart_alt" },
                            on: { btnClicked: _vm.SetRevision },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.editable &&
                                  _vm.popupParam.psiValveRuptureId &&
                                  _vm.isRevision &&
                                  _vm.isEnalbed,
                                expression:
                                  "(editable && popupParam.psiValveRuptureId && isRevision) && isEnalbed",
                              },
                            ],
                            attrs: {
                              label: "LBLREVCANCEL",
                              icon: "restart_alt",
                            },
                            on: { btnClicked: _vm.CancelRevision },
                          }),
                          _vm.editable &&
                          _vm.popupParam.psiValveRuptureId &&
                          _vm.isEnalbed
                            ? _c("c-btn", {
                                attrs: { label: "LBLREMOVE", icon: "remove" },
                                on: { btnClicked: _vm.deleteData },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.mappingType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "LBL0010434",
                            name: "valveRuptureNo",
                          },
                          model: {
                            value: _vm.data.valveRuptureNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "valveRuptureNo", $$v)
                            },
                            expression: "data.valveRuptureNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "LBL0010391",
                            name: "inMaterial",
                          },
                          model: {
                            value: _vm.data.inMaterial,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "inMaterial", $$v)
                            },
                            expression: "data.inMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010435",
                            name: "conditionVal",
                          },
                          model: {
                            value: _vm.data.conditionVal,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "conditionVal", $$v)
                            },
                            expression: "data.conditionVal",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.data.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "plantCd", $$v)
                            },
                            expression: "data.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-process", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0001705",
                            multiple: "single",
                            plantCd: _vm.data.plantCd,
                            name: "processCd",
                          },
                          model: {
                            value: _vm.data.processCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "processCd", $$v)
                            },
                            expression: "data.processCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-dept", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0001721",
                            plantCd: _vm.data.plantCd,
                            name: "deptCd",
                          },
                          model: {
                            value: _vm.data.deptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "deptCd", $$v)
                            },
                            expression: "data.deptCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0010455" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "kg/hr",
                            editable: _vm.editable,
                            label: "LBL0010436",
                            name: "outVolume",
                          },
                          model: {
                            value: _vm.data.outVolume,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "outVolume", $$v)
                            },
                            expression: "data.outVolume",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "kg/hr",
                            editable: _vm.editable,
                            label: "LBL0010437",
                            name: "regulVolume",
                          },
                          model: {
                            value: _vm.data.regulVolume,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "regulVolume", $$v)
                            },
                            expression: "data.regulVolume",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010456",
                            name: "nozzleSizeIn",
                          },
                          model: {
                            value: _vm.data.nozzleSizeIn,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "nozzleSizeIn", $$v)
                            },
                            expression: "data.nozzleSizeIn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010457",
                            name: "nozzleSizeOut",
                          },
                          model: {
                            value: _vm.data.nozzleSizeOut,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "nozzleSizeOut", $$v)
                            },
                            expression: "data.nozzleSizeOut",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0010458" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010442",
                            name: "protectSerial",
                          },
                          model: {
                            value: _vm.data.protectSerial,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "protectSerial", $$v)
                            },
                            expression: "data.protectSerial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "Mpa",
                            editable: _vm.editable,
                            label: "LBL0010443",
                            name: "protectOperation",
                          },
                          model: {
                            value: _vm.data.protectOperation,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "protectOperation", $$v)
                            },
                            expression: "data.protectOperation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "Mpa",
                            editable: _vm.editable,
                            label: "LBL0010446",
                            name: "protectDesign",
                          },
                          model: {
                            value: _vm.data.protectDesign,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "protectDesign", $$v)
                            },
                            expression: "data.protectDesign",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0010459" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "Mpa",
                            editable: _vm.editable,
                            label: "LBL0010446",
                            name: "valveSetting",
                          },
                          model: {
                            value: _vm.data.valveSetting,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "valveSetting", $$v)
                            },
                            expression: "data.valveSetting",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010447",
                            name: "safetyValveMaterial",
                          },
                          model: {
                            value: _vm.data.safetyValveMaterial,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "safetyValveMaterial", $$v)
                            },
                            expression: "data.safetyValveMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010448",
                            name: "safetyValveTrim",
                          },
                          model: {
                            value: _vm.data.safetyValveTrim,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "safetyValveTrim", $$v)
                            },
                            expression: "data.safetyValveTrim",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기타 정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010449",
                            name: "precisionVal",
                          },
                          model: {
                            value: _vm.data.precisionVal,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "precisionVal", $$v)
                            },
                            expression: "data.precisionVal",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010450",
                            name: "outConnect",
                          },
                          model: {
                            value: _vm.data.outConnect,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "outConnect", $$v)
                            },
                            expression: "data.outConnect",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010451",
                            name: "outReason",
                          },
                          model: {
                            value: _vm.data.outReason,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "outReason", $$v)
                            },
                            expression: "data.outReason",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            label: "LBL0010452",
                            name: "formVal",
                          },
                          model: {
                            value: _vm.data.formVal,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "formVal", $$v)
                            },
                            expression: "data.formVal",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              staticStyle: { "padding-top": "20px !important" },
            },
            [
              _c("c-upload", {
                attrs: {
                  attachInfo: _vm.attachInfo,
                  editable: _vm.editable,
                  label: "LBLATTACHMENT",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }